/* eslint-disable */
// Generic priority sorter

export const sortWithSpecificIdAtEnd = (arr: any[], specificId: string) => {
	arr.sort((a, b) => (a.id === specificId ? 1 : b.id === specificId ? -1 : 0));
	return arr;
};

export const sortWithSpecificId = (
	arr: any[],
	specificId: string,
	position: "first" | "last"
) => {
	const order = position === "first" ? -1 : 1;
	arr.sort((a, b) =>
		a.id === specificId ? order : b.id === specificId ? -order : 0
	);
	return arr;
};

export const sortByPriority = <T extends { priority: number }>(
	arr?: T[] | readonly T[]
) => {
	if (!Array.isArray(arr)) return [] as T[];
	return [...arr].sort((a, b) => a.priority - b.priority);
};

export const sortByOrderMap = <T extends { id: string }>(
	arr: T[] | readonly T[] | undefined,
	orderMap: Record<string, number>,
	defaultOrder = Number.MAX_SAFE_INTEGER
) => {
	if (!Array.isArray(arr)) return [] as T[];

	return [...arr]
		.map((item, index) => ({
			item,
			index,
			order: orderMap[item.id] ?? defaultOrder
		}))
		.sort((a, b) => a.order - b.order || a.index - b.index)
		.map(({ item }) => item);
};
